import styled from "styled-components";
import { A, Body } from "@songtradr/design-language";
import { staticText } from "../../../../shared/statics/static-text";

// TEXT
export const text = staticText.emailSignUp.legals;

// STYLES
export const Container = styled(Body)`
  text-align: center;
`;

export const AgreementLink = styled(A)`
  text-decoration: underline !important;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
